import { cva } from 'class-variance-authority';

export const cvaCheckboxWrapper = cva([
  'CheckboxStyles-cvaCheckboxWrapper',
  'flex gap-1.2 items-center',
]);

export const cvaCheckboxUnchecked = cva([
  'CheckboxStyles-cvaCheckbox',
  'relative',
  'block size-[25px]',
  'bg-cDarkGray',
  'rounded-[0.4rem]',
  'border-[3px] border-cGray',
]);

export const cvaCheckboxChecked = cva([
  'CheckboxStyles-cvaCheckbox',
  'relative',
  'block size-[25px]',
  'rounded-[0.4rem]',
]);
